import styled from "styled-components";

export const UploadModeButton = styled.button`
  position: absolute;
  right: calc(100% + 8px);
  top: 0;
  border: none;
  padding: 0;
  font: inherit;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  display: inline-flex;
  align-items: center;
  height: ${({ theme }) => theme.iconSize.lg};
  border-radius: ${({ theme }) => theme.br.pill};
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.textLight};
  overflow: hidden;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateX(${({ $visible }) => ($visible ? "0" : "10px")});
  pointer-events: ${({ $visible }) => ($visible ? "auto" : "none")};
  transition: opacity 0.18s ease, transform 0.22s cubic-bezier(0.2, 0.6, 0.2, 1);

  &:focus-visible {
    outline: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    position: static;
    margin-top: 0;
    margin-right: 8px;
    flex-shrink: 0;
    opacity: 1;
    transform: none;
    pointer-events: auto;
  }
`;

export const UploadModeLabel = styled.span`
  max-width: 0;
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
  font-family: ${({ theme }) => theme.p3b.ff};
  font-size: 13px;
  line-height: 1;
  letter-spacing: 0.2px;
  opacity: 0;
  transition: max-width 0.28s cubic-bezier(0.2, 0.6, 0.2, 1),
    padding 0.28s cubic-bezier(0.2, 0.6, 0.2, 1), opacity 0.18s ease 0.08s;

  ${UploadModeButton}:hover &,
  ${UploadModeButton}:focus-visible & {
    max-width: 120px;
    padding: 0 4px 0 14px;
    opacity: 1;
  }
`;

export const UploadModeIconSide = styled.span`
  width: ${({ theme }) => theme.iconSize.lg};
  height: ${({ theme }) => theme.iconSize.lg};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
